import { FunctionalComponent, h } from '@stencil/core';
import { IIconProps } from './interfaces';

const FilledError: FunctionalComponent<IIconProps> = ({ width = '16', height = '16', fill = '#666' }) => (
  /*@ts-ignore*/
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 13.9999C12.5523 13.9999 13 13.5522 13 12.9999V6.99991C13 6.44762 12.5523 5.99991 12 5.99991C11.4477 5.99991 11 6.44762 11 6.99991V12.9999C11 13.5522 11.4477 13.9999 12 13.9999ZM12 16.0001C11.4477 16.0001 11 16.4478 11 17.0001C11 17.5524 11.4477 18.0001 12 18.0001C12.5523 18.0001 13 17.5524 13 17.0001C13 16.4478 12.5523 16.0001 12 16.0001Z"
      fill={fill}
    />
  </svg>
);

export default FilledError;
